import { createCache } from '@timeflies/cache';
export var textureCache = createCache();
